import React, { useMemo } from "react";
import type { Accessory } from "interfaces/schemas/accessories";
import { useProductImage } from "hooks";
import OrderCodePart from "components/_ProductConfigurator/SubComponents/OrderCodePart";
import { ExpandableText } from "components/ExpandableText/ExpandableText";

interface ISelectedAccessoryDetailsProps {
  selectedAccessory: Accessory;
}

export const SelectedAccessoryDetails: React.FC<
  ISelectedAccessoryDetailsProps
> = ({ selectedAccessory }) => {
  const { productImage, fetching } = useProductImage(selectedAccessory?.pimId);

  const presentationParts = useMemo(
    () =>
      selectedAccessory?.ordercode?.parts.filter(
        (part) =>
          // 0 - RelevantChangeable; 1 - RelevantNotChangeable
          // https://dev.azure.com/DEVLY-IT-Software-Development/TROX-EB-Website_v2/_wiki/wikis/TROX-System-Configurator.wiki/1132/Product-states
          part.state === 0 ||
          part.state === 1 ||
          (part.state === 3 && part.presentation),
      ) || [],
    [selectedAccessory?.ordercode],
  );

  return (
    selectedAccessory &&
    !!selectedAccessory.seriesId && (
      <div className="mt-2 d-flex align-items-start gap-4 flex-column">
        <div className="d-flex p-3 align-items-center flex-wrap">
          {selectedAccessory.pimId && productImage && (
            <div
              className="flex-shrink-0 me-5"
              style={{ width: "100px", height: "100px" }}
            >
              <img
                src={productImage}
                className="w-100 h-100 object-fit-contain m-0"
                alt={selectedAccessory.currentPresentation}
              />
            </div>
          )}
          <div className="align-self-center flex-shrink-0">
            <div className="d-flex gap-1 align-items-center mb-2 ">
              <h3 className="mb-0" style={{ fontSize: "20px" }}>
                {selectedAccessory.currentPresentation.replace(/\//g, " ")}
              </h3>
            </div>
            <div className="d-flex flex-wrap gap-2 pe-none opacity-50">
              {presentationParts.map((part) => (
                <OrderCodePart
                  key={part.key}
                  part={part}
                  activePart={null}
                  activatePartItem={null}
                  isFetchingOrderCodeProcess={fetching}
                  isConfigurationModalOpened={false}
                />
              ))}
            </div>
          </div>
        </div>
        {selectedAccessory.infoText && (
          <ExpandableText>{selectedAccessory.infoText}</ExpandableText>
        )}
      </div>
    )
  );
};
